import React from 'react';
import { getDestinationsAdmin, deleteDestination } from '../../../api/contentAdminApi';
import CmsAdminList from './CmsAdminList';

export default function DestinationsAdminList() {
	return (
		<CmsAdminList
			title="Destinations"
			description="Cities, lakes, temples, national parks, and other places."
			addHref="/admin/cms/destination_form"
			formPath="/admin/cms/destination_form"
			resourceKey="destinations"
			fetchList={getDestinationsAdmin}
			deleteItem={deleteDestination}
			getRowTitle={(row) => row.name}
			getRowSubtitle={(row) => row.category}
		/>
	);
}
